module.exports = __webpack_public_path__ + "static/media/team.f9e65fc9.jpg";